// src/data/quotes.js

const quotes = [
  {
    text: "Almost everything will work again if you unplug it for a few minutes, including you.",
    author: "Anne Lamott"
  },
  {
    text: "You don't have to control your thoughts. You just have to stop letting them control you.",
    author: "Dan Millman"
  },
  {
    text: "The greatest weapon against stress is our ability to choose one thought over another.",
    author: "William James"
  },
  {
    text: "Self-care is how you take your power back.",
    author: "Lalah Delia"
  },
  {
    text: "Slow down and everything you are chasing will come around and catch you.",
    author: "John De Paola"
  },
  {
    text: "Rest and self-care are so important. When you take time to replenish your spirit, it allows you to serve others.",
    author: "Eleanor Brownn"
  },
  {
    text: "Almost everything will fall into place if you let go of trying to control it.",
    author: "Unknown"
  },
  {
    text: "Sometimes the most productive thing you can do is relax.",
    author: "Mark Black"
  },
  {
    text: "Do something today that your future self will thank you for.",
    author: "Sean Patrick Flanery"
  },
  {
    text: "Taking care of yourself doesn't mean me first, it means me too.",
    author: "L.R. Knost"
  },
  {
    text: "Breathe. Let go. And remind yourself that this very moment is the only one you know you have for sure.",
    author: "Oprah Winfrey"
  },
  {
    text: "It's not selfish to love yourself, take care of yourself, and to make your happiness a priority.",
    author: "Mandy Hale"
  },
  {
    text: "Sometimes the most important thing in a whole day is the rest we take between two deep breaths.",
    author: "Etty Hillesum"
  },
  {
    text: "Self-care is giving the world the best of you, instead of what's left of you.",
    author: "Katie Reed"
  },
  {
    text: "Calm mind brings inner strength and self-confidence, so that's very important for good health.",
    author: "Dalai Lama"
  },
  {
    text: "If your compassion does not include yourself, it is incomplete.",
    author: "Jack Kornfield"
  },
  {
    text: "You can't pour from an empty cup. Take care of yourself first.",
    author: "Unknown"
  },
  {
    text: "Take rest; a field that has rested gives a bountiful crop.",
    author: "Ovid"
  },
  {
    text: "When you say yes to others, make sure you are not saying no to yourself.",
    author: "Paulo Coelho"
  },
  {
    text: "Almost everything will work better if you unplug it for a while, including you.",
    author: "Anne Lamott"
  }
];

export default quotes;
